export default __webpack_public_path__ + "static/media/wave-mobile180-bg.38af051a.png";